"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = reducer;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _phoneNumbersActions = require("../actions/PhoneNumbers/phoneNumbersActions");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var initialState = {
  phoneNumbers: [],
  processedPhoneNumber: {},
  apiErrorMessage: '',
  changeEvent: _phoneNumbersActions.PhoneNumberChangeEvent.NONE,
  isLoading: false,
  hasApiError: false
};
function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case _phoneNumbersActions.PhoneNumberActions.IS_LOADING:
      return _objectSpread(_objectSpread({}, state), {}, {
        apiErrorMessage: '',
        hasApiError: false,
        isLoading: true
      });
    case _phoneNumbersActions.PhoneNumberActions.IS_EDITING:
      return _objectSpread(_objectSpread({}, state), {}, {
        changeEvent: action.changeEvent,
        apiErrorMessage: '',
        hasApiError: false,
        isLoading: true
      });
    case _phoneNumbersActions.PhoneNumberActions.FINISHED_EDITING:
      return _objectSpread(_objectSpread({}, state), {}, {
        processedPhoneNumber: action.processedPhoneNumber,
        apiErrorMessage: '',
        hasApiError: false,
        isLoading: false
      });
    case _phoneNumbersActions.PhoneNumberActions.RESET_CHANGE_EVENT_TYPE:
      return _objectSpread(_objectSpread({}, state), {}, {
        changeEvent: _phoneNumbersActions.PhoneNumberChangeEvent.NONE,
        hasApiError: false,
        apiErrorMessage: '',
        processedPhoneNumber: {}
      });
    case _phoneNumbersActions.PhoneNumberActions.RESET_API_ERROR:
      return _objectSpread(_objectSpread({}, state), {}, {
        apiErrorMessage: '',
        hasApiError: false
      });
    case _phoneNumbersActions.PhoneNumberActions.LOAD_PHONE_NUMBERS:
      return _objectSpread(_objectSpread({}, state), {}, {
        isLoading: false,
        phoneNumbers: action.phoneNumbers
      });
    case _phoneNumbersActions.PhoneNumberActions.HAS_API_ERROR:
      return _objectSpread(_objectSpread({}, state), {}, {
        isLoading: false,
        hasApiError: true,
        apiErrorMessage: action.apiErrorMessage
      });
    default:
      return state;
  }
}